module.exports = __webpack_public_path__ + "static/media/Calendar.b85d9389.png";